export default __webpack_public_path__ + "static/media/image.f0aa3c25.png";